/**
 * i18n国际化
 */

// 简体中文
import zhCN from './lang/zh-CN';
// 英文
import en from './lang/en';

export default {
    'zh-CN': zhCN,
    en,
};
